import React from 'react';
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';

import { styles, mergeStyles } from './styles';

export { modalStyles } from './modalStyles';

interface Props {
  open: boolean;
  handleClose: () => void;
  title: string;
  children: React.ReactNode;
  showCloseIcon?: boolean;
  centerTitle?: boolean;
  customHeader?: React.ReactNode;
  dialogActions?: React.ReactNode;
  sxContent?: SxProps<Theme>;
  sxActions?: SxProps<Theme>;
  sxPaper?: SxProps<Theme>;
  dialogWidth?: string;
  disableBackdropClick?: boolean;
}

const CustomModal = ({
  open,
  handleClose,
  title,
  children,
  centerTitle,
  showCloseIcon,
  customHeader,
  dialogActions,
  sxContent,
  sxActions,
  sxPaper,
  dialogWidth = '50%',
  disableBackdropClick,
}: Props) => {
  const handleDlgClose = (_event: object, reason: string) => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return;
    }
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDlgClose}
      fullWidth
      PaperProps={{
        sx: {
          maxWidth: dialogWidth,
          ...(sxPaper && typeof sxPaper === 'object' && !Array.isArray(sxPaper)
            ? (sxPaper as object)
            : {}),
        },
      }}
      slotProps={{
        backdrop: {
          sx: styles.backdrop,
        },
      }}
      sx={styles.background}
      disableEscapeKeyDown={disableBackdropClick}
    >
      <DialogTitle>
        {customHeader ? (
          <>{customHeader}</>
        ) : (
          <Box sx={centerTitle ? styles.containerTitle2 : styles.containerTitle}>
            <Typography variant="h5">{title}</Typography>
            {showCloseIcon ? (
              <IconButton
                size="small"
                aria-label="close"
                onClick={handleClose}
                color="primary"
                sx={centerTitle ? styles.closeIcon : undefined}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </Box>
        )}
      </DialogTitle>
      <DialogContent sx={mergeStyles(styles.dialogContent, sxContent)}>
        {children}
      </DialogContent>
      {dialogActions ? (
        <DialogActions sx={mergeStyles(styles.actionsContainer, sxActions)}>
          {dialogActions}
        </DialogActions>
      ) : null}
    </Dialog>
  );
};

export default CustomModal;
